import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { GetDojoName, GetGradeName } from "../Utils";

export default function QueryQualifyDateDetail(props) {
  let params = useParams();
  const dateId = params.id;

  const STATE_APPROVED = "NEW";
  const STATE_CREATED = "CREATED";
  const STATE_UPDATED = "UPDATED";
  const STATE_NOTAPPROVED = "NOTAPPROVED";
  const STATE_ABSENT = "ABSENT";

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);

  const [detail, setDetail] = useState(null);
  const [exams, setExams] = useState([]);

  const token = JSON.parse(ls.get("jwt"));
  const history = useHistory();

  useEffect(() => {
    GetExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetExams = async () => {
    setLoading(true);

    const dojosList = JSON.parse(ls.get("dojos"));
    const gradesList = JSON.parse(ls.get("grades"));

    const detail = await axios.get(
      `${API_URL}/examinations/${dateId}?populate=examiner`,
      headerRequest
    );
    const examinationDetail = detail.data.data;
    setDetail(examinationDetail);

    const res = await axios.get(
      `${API_URL}/temp-exams?populate=*&filters[examination][id][$eq]=${dateId}`,
      headerRequest
    );
    const exams = res.data.data;

    Promise.all(
      exams.map(async (exam) => {
        exam.grade = GetGradeName(gradesList, exam.attributes.grade_id);
        exam.dojo = GetDojoName(dojosList, exam.attributes.dojo_id);

        const tempUser = exam.attributes.tempUser;
        if (tempUser && tempUser.data && tempUser.data.id) {
          exam.email = tempUser.data.attributes.email;
          exam.fullname =
            tempUser.data.attributes.lastname +
            ", " +
            tempUser.data.attributes.name;
          exam.tempUserId = tempUser.data.id;
        }

        return exam;
      })
    ).then((exams) => {
      setExams(exams);
      setLoading(false);
    });
  };

  function MapState(state) {
    if (state === STATE_APPROVED) return "Aprobado";
    if (state === STATE_CREATED) return "Aprobado";
    if (state === STATE_UPDATED) return "Aprobado";
    if (state === STATE_ABSENT) return "Ausente";
    if (state === STATE_NOTAPPROVED) return "Desaprobado";
    return "Pendiente";
  }

  const renderData = (
    <Table striped hover size="sm" responsive="sm">
      <thead>
        <tr>
          <th>DNI</th>
          <th>Nombre</th>
          <th>Email</th>
          <th>Grado</th>
          <th>Dojo</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {exams.length < 1 ? (
          <tr>
            <td colSpan="5" align="center">
              No hay exámenes.
            </td>
          </tr>
        ) : (
          exams.map((exam) => (
            <tr key={exam.id}>
              <td align="center">{exam.attributes.docNumber}</td>
              <td align="left">{exam.fullname}</td>
              <td align="left">{exam.email}</td>
              <td align="center">{exam.grade}</td>
              <td align="left">{exam.dojo}</td>
              <td align="center" className="w270">
                <Button disabled variant="outline-secondary">
                  {MapState(exam.attributes.state)}
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <p style={{ textAlign: "left" }}>
        <Button size="sm" variant="primary" onClick={history.goBack}>
          VOLVER
        </Button>
      </p>
      <h4>REPORTE DE FECHAS PASADAS</h4>
      {detail ? (
        <p>
          Fecha: <b>{detail.attributes.date}</b>, Modalidad:{" "}
          <b>{detail.attributes.mode}</b>, Grado:{" "}
          <b>{detail.attributes.rank}</b>
        </p>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
